import React, { useState } from "react";
import SwitchView from "../SwitchView/SwitchView";

import "./FiltersAndViews.css";

import FilterIcon from "../../assets/filter-icon.svg";
import CloseButton from "../../assets/close-icon.svg";
import Filters from "./Filters/Filters";

const FiltersAndViews = () => {
  const [isFilterActive, setIsFilterActive] = useState(true);

  const expandFilterSection = () => {
    const coll = document.getElementById(
      "delicious100-interactive__filters_all_id"
    );
    if (coll.style.maxHeight) {
      coll.style.maxHeight = null;
    } else {
      coll.style.maxHeight = "100%";
    }
  };

  return (
    <div className="delicious100-interactive__filter_section">
      <div className="delicious100-interactive__filter_buttons">
        <div>
          <SwitchView></SwitchView>
        </div>
        {isFilterActive ? (
          <img
            className="delicious100-interactive__filter_buttons_filter"
            src={FilterIcon}
            alt="FilterIcon"
            onClick={() => {
              expandFilterSection();
              setIsFilterActive(false);
            }}
          ></img>
        ) : (
          <img
            className="delicious100-interactive__filter_buttons_filter"
            src={CloseButton}
            alt="CloseButton"
            onClick={() => {
              setIsFilterActive(true);
              expandFilterSection();
            }}
          ></img>
        )}
      </div>
      <span className="delicious100-interactive__filter_text">
        The results are in! We've tallied the votes and can now reveal the Best
        of the Best eats and treats in your state. Scroll to reveal the overall
        winner in each category and how the top five placed, as decided by you.
        Click on a tile to read more about each venue. Select the map view to
        see which venues are located near you. See full terms and conditions{" "}
        <a
          href="https://origin.go.dailytelegraph.com.au/wp-content/uploads/2023/10/TCs-2023-Delicious100-Consumer-Competition-2.pdf"
          target="_blank"
          rel="noreferrer"
        >
          here
        </a>
      </span>
      <br></br>
      <span className="delicious100-interactive__filter_text">
        Now the wait is over - We have narrowed it down to the top 5 in each
        category! Do you agree with the list?
      </span>
      <br></br>
      <div className="delicious100-interactive__filter_text_last">
        <span className="delicious100-interactive__filter_text">
          {/* <span className="delicious100-interactive__filter_text_bold">
            TO VOTE:{" "}
          </span> */}
          <strong>Voting is now closed</strong>
        </span>
        {/* <VoteButton
          onClick={() => console.log("Clicked")}
          isDefaultActive={true}
        ></VoteButton> */}
      </div>
      <br></br>
      <span className="delicious100-interactive__filter_text">
        Thank you to everyone who voted for their favourite eats and treats in
        the <i>delicious.</i> 100. Congratulations to the following ten readers
        who have won a $500 dining voucher: D. Wilson (NSW), D. Callander (NSW),
        M. Ahern (QLD), E. Sweeney (QLD), K. Hanbury (SA), D. Potts (SA), E.
        Hetrel (VIC), H. Bozelle (VIC), R. Gobbey (TAS) and S. O'Neill (TAS).
      </span>
      <Filters></Filters>
    </div>
  );
};

export default FiltersAndViews;
